import AudioInputVFControl from "./AudioInputVFControl";
import { ContainerBreakpoints } from "../../videoMeeting.types";

export type Props = {
  containerBreakpoints: ContainerBreakpoints;
};

export function VideoMeetingControlsAudioInputContainer({
  containerBreakpoints,
}: Props) {
  return <AudioInputVFControl containerBreakpoints={containerBreakpoints} />;
}

export default VideoMeetingControlsAudioInputContainer;
